import React from 'react';
import Header from './Header';
import OverallScore from './OverallScore';
import ScoreHistoryChart from './ScoreHistoryChart';
import ChartsCarousel from './ChartsCarousel';
import UrgentActions from './UrgentActions';
import ApexTests from './ApexTests';
import CategoriesOverview from './CategoriesOverview';
import CategoryDetails from './CategoryDetails';
import Recommendations from './Recommendations';
import PresaleIdeas from './PresaleIdeas';
import GitContributors from './GitContributors';
import Footer from './Footer';

const Dashboard = ({ data, onLogout }) => {
  return (
    <div className="space-y-6">
      <Header
        projectName={data.projectName}
        displayName={data.displayName}
        evaluationDate={data.evaluationDate}
        projectType={data.projectType}
        data={data}
      />
      <OverallScore score={data.overallScore} />
      <ScoreHistoryChart currentScore={data.overallScore} projectName={data.projectName} />
      <ChartsCarousel categories={data.categories} />
      <CategoriesOverview categories={data.categories} />
      <UrgentActions urgentActions={data.urgentActions} projectName={data.projectName} />
      <GitContributors gitContributors={data.gitContributors} />
      <ApexTests apexTests={data.apexTests} />
      <PresaleIdeas presaleIdeas={data.presaleIdeas} />
      <Recommendations overallRecommendations={data.overallRecommendations} keyStrengths={data.keyStrengths} keyAreasForImprovement={data.keyAreasForImprovement} areasForImprovement={data.areasForImprovement} />
      {data.categories.map((category, index) => {
        const getCategoryId = (categoryName) => `category-${categoryName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')}`;
        return (
          <div key={index} id={getCategoryId(category.name)}>
            <CategoryDetails category={category} />
          </div>
        );
      })}
      <Footer />
    </div>
  );
};

export default Dashboard;
